import { createAction, props } from '@ngrx/store';
import { Provider } from '@ipensii/shared/domain-shared';

export class ProviderActions {
  static readonly loadProviders = createAction('[Shared - Provider] - Load Providers');
  static readonly loadProvidersSuccess = createAction(
    '[Shared - Provider] - Load Providers Success',
    props<{ providers: Array<Provider> }>()
  );
  static readonly loadProvidersError = createAction(
    '[Shared - Provider] - Load Providers Error',
    props<{ error: Error }>()
  );
}
